import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import changeableItemsReducer from './changeableItemsSlice';

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['changeableItems'], // Only persist changeableItems
};

// Create root reducer using combineReducers
const rootReducer = combineReducers({
  changeableItems: changeableItemsReducer,
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with persisted reducer
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

// Create persistor
export const persistor = persistStore(store);

export default store;